import { render } from "./CustomerDetailsCardWaitlist.vue?vue&type=template&id=765c62d0&scoped=true&ts=true&lang=pug"
import script from "./CustomerDetailsCardWaitlist.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerDetailsCardWaitlist.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerDetailsCardWaitlist.vue?vue&type=style&index=0&id=765c62d0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765c62d0"]])

export default __exports__